import { SMSTemplateMaster, SendFreeFormSmsRequest, SendSmsTemplateRequest, SmsTemplateMasterResponse } from '../../../../models/src/lib/notifications/sms/smstemplatemaster';
import { EmailFromMasterResponse } from '../../../../models/src/lib/notifications/emails/emailfrommaster';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { EmailTemplateMasterById, EmailTemplateMasterResponse, ListWhatsAppSenderConfigurationMasterResponse, ListWhatsAppTemplateMaster, NotificationMasterResponse, SMSFromMasterResponse, SendEmailTemplateRequest, SendFreeFormEmailRequest, ThreadResponse, WhatsAppTemplateMaster } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { OwnershipLevel } from '@fitness-force/enum';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private http: HttpClient, private router: Router) { }
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  
  getNotificastionTemplates(tenantId:number): Observable<NotificationMasterResponse> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/notifications`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplates(tenantId:number): Observable<EmailTemplateMasterResponse> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplateById(tenantId:number, templateId:number): Observable<EmailTemplateMasterById> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master/${templateId}`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSmsTemplates(tenantId:number): Observable<SmsTemplateMasterResponse> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplates(tenantId:number): Observable<ListWhatsAppTemplateMaster> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendEmailFromList(tenantId:number): Observable<EmailFromMasterResponse> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/email_from_config_master`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendSMSFromList(tenantId:number): Observable<SMSFromMasterResponse> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSMSTemplateById(tenantId:number, templateId:number): Observable<SMSTemplateMaster> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master/${templateId}`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendFreeFormSms(tenantId:number,clientId:number, payload:SendFreeFormSmsRequest): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/send_free_form_sms`;
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedSms(tenantId:number,clientids:any[],payload:SendSmsTemplateRequest): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/send_templated_sms`;
    const encodedArray = clientids.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendFreeFormEmail(tenantId:number,clientId:number,payload:SendFreeFormEmailRequest): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/send_free_form_email`;
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedEmail(tenantId:number, clientids:any[], payload:SendEmailTemplateRequest): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/send_templated_email`;
    const encodedArray = clientids.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendWhatsAppMessage(tenantId:number,clientId:number,payload:any): Observable<any> {
    const url= `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/send_free_form_whatsapp`;
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    },
   
    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if(error.status === 400){
          return throwError(()=> new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedWhatsAppMessage(tenantId:number,clientIds:any[],payload:any): Observable<any> {
    const url= `${environment.BASE_URL}/tenants/${tenantId}/clients/send_templated_whatsapp`;
    const encodedArray = clientIds.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if(error.status === 400){
          return throwError(()=> new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  // Automation Changes

  getEmailTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<EmailTemplateMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/email_template_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/email_template_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master`;
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplateByIdWithOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<EmailTemplateMasterById> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/email_template_master`
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/email_template_master/${templateId}`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master/${templateId}`
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendEmailFromListByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<EmailFromMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/email_from_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/email_from_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_from_config_master`
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendSMSFromListByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<SMSFromMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_sender_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_sender_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSmsTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<SmsTemplateMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_template_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_template_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master`
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSMSTemplateByIdWithOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<SMSTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/sms_template_master`
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/sms_template_master/${templateId}`;
        break;
      case OwnershipLevel.Tenant:
        url =  `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master/${templateId}`
        break;
      default:
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`;
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ListWhatsAppSenderConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppSenderConfigurationMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_config_master`;
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_config_master`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_config_master`
        break;
      default:
        break;
    }
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetWhatsAppTemplateMasterByOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<WhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/whatsapp_template_master`
        break;
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseGroupId}/whatsapp_template_master/${templateId}`;
        break;
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`
        break;
      default:
        break;
    }
    return this.http.get<WhatsAppTemplateMaster>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientThreads(tenantId: any, allParams: Array<any>): Observable<ThreadResponse> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/threads`,
     {headers: this.httpOptions.headers , params: parsedParams}).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  markAsRead(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/email/threads/${threadId}/messages/${interactionId}/mark_as_read`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsSmsRead(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/sms/messages/${interactionId}/mark_as_read`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsWhatsappRead(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/whatsapp/messages/${interactionId}/mark_as_read`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })  
      );
  }

  markAsSmsUnread(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/sms/messages/${interactionId}/mark_as_unread`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })  
      );
  }

  markAsWhatsappUnread(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/whatsapp/${threadId}/messages/${interactionId}/mark_as_unread`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }), 
        catchError((error: Response) => {   
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsEmailUnread(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/clients/${clientId}/email/${threadId}/messages/${interactionId}/mark_as_unread`;
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res; 
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));  
        })
      );
  }
  
}